<calendar-viewer #calendarViewer [locale]="locale" (onChange)="changeMonth($event)" (onActive)="activeDate($event)"></calendar-viewer>
<div class="calendar-container" *ngIf="activeDateViewer?.events?.length">
    <div class="calendar-event__date">{{activeDateTitle}}</div>
    <div #viewToggle class="calendar-body">
        <div *ngFor="let event of activeDateViewer?.events" #targetEl (click)="onViewEvent(event, $event, targetEl)"  class="calendar-event">
            <div  class="calendar-event__state" [ngStyle]="event.style"></div>
            <div class="calendar-event__content">
                <div class="calendar-event__title">
                    {{event.subject}}
                    <div class="calendar-event__progress" [style.color]="event.statusColor">{{event.statusText}}</div>
                </div>
                <div class="calendar-event__text">
                    <i class="fa fa-clock-o calendar-event__icon"></i>
                    {{event.hourStr}}
                </div>
                <div *ngIf="event.location" class="calendar-event__text">
                    <i class="fa fa-map-marker calendar-event__icon"></i>
                    {{event.location}}
                </div>
            </div>
        </div>
    </div>
</div>
